export default __webpack_public_path__ + "static/media/d-3.10145e91.jpg";